import { Constants } from "../constants/Contants";
import request from "../utils/useApi";
import { get, post } from '../utils/request';


export const getAllEsimPackages = async (data) => {
  try {
    const res = await request.post(
      `${Constants.get_all_esim_packages_api_url}`,
      data
    );
    if (res) {
      return res.data;
    }
  } catch (e) {
    throw e;
  }
};

export const getSupportedLocations = async () => {
  try {
    const res = await request.post(
      `${Constants.get_supported_locations_api_url}`,
      {}
    );
    if (res) {
      return res.data;
    }
  } catch (e) {
    throw e;
  }
};

export const requestEsimPreorder = async (selectedPackage) => {
  try {
    const esimPreorderResult = await post(Constants.esimPreorder, selectedPackage);
    return esimPreorderResult;
  } catch (error) {
    console.error("Failed to request esim preorder:", error);
    return null;
  }
};
